import React, {useState} from 'react'
import RootAdmin from '../../../../components/layouts/RootAdmin'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownTrigger,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableColumn,
    TableHeader,
    TableRow
} from '@nextui-org/react'
import HeaderPage from '../../../../components/elements/HeaderPage'
import { FunnelIcon } from '@heroicons/react/24/outline'
import { BarChart } from '@mui/x-charts/BarChart';
import useSWR from "swr";
import {getFetcher, HIGHCHART_URL} from "../../../../services/api";
import {useForm} from "react-hook-form";
import ControlledInput from "../../../../components/elements/ControlledInput";
import {format} from 'date-fns'
import { translateMonth } from '../../../../services/helpers'
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function PelaporanPenyimpananGrafik() {

    const [selectedProvince, setSelectedProvince] = useState('');

    const { data: provinces } = useSWR('/api/location/provinces', getFetcher);

    const { data: dataProvince, mutate: mutateProvince } = useSWR(
        `/api/dashboard/pelaporan/penyimpanan/sebaran-by-province`,
        getFetcher
    );

    const { data: dataRegencies, mutate: mutateRegencies } = useSWR(
        `/api/dashboard/pelaporan/penyimpanan/sebaran-by-regency`,
        getFetcher
    );

    const { data: perusahaan, mutate: mutatePerusahaan } = useSWR(
        `/api/dashboard/pelaporan/penyimpanan/count-by-company`,
        getFetcher
    );


    const handleFilterApply = (data) => {
        mutateProvince();
        mutateRegencies();
        mutatePerusahaan();
    };

    return (<RootAdmin>
            <HeaderPage
                title="Grafik Penyimpanan B3"
                subtitle="Gambaran Umum"
            />
            <div className='grid grid-rows-1 md:grid-rows-4 gap-3 pt-5'>
                <Card>
                    <Tabs aria-label="Penyimpanan Grafik B3" defaultValue="wilayah">
                        <Tab title="Grafik Penyimpanan B3 Per Provinsi" value="wilayah">
                            {renderChartAndTableForRealisasi(
                                    dataProvince?.responseData,
                                    "Grafik Penyimpanan B3 Per Provinsi",
                                    ["Provinsi", "Total"],
                                    ["provinceName", "count"],
                                    "provinceName",
                                    "count"
                                )}
                        </Tab>

                        <Tab title="Grafik Penyimpanan B3 Per Kota/Kabupaten" value="kota">
                        {renderChartAndTableForRealisasi(
                                    dataRegencies?.responseData,
                                    "Grafik Penyimpanan B3 Per Kota/Kabupaten",
                                    ["Kota/Kabupaten", "Total"],
                                    ["regencyName", "count"],
                                    "regencyName",
                                    "count"
                                )}
                        </Tab>
                        <Tab title="Grafik Penyimpanan B3 Per Perusahaan" value="company">
                        {renderChartAndTableForRealisasi(
                                    perusahaan?.responseData,
                                    "Grafik Penyimpanan B3 Per Perusahaan",
                                    ["Nama Perusahaan", "Total"],
                                    ["companyName", "count"],
                                    "companyName",
                                    "count"
                                )}
                        </Tab>
                    </Tabs>
                </Card>
            </div>
        </RootAdmin>)
}

function FilterForm(onApplyFilter) {

    const handleApply = (data) => {
        onApplyFilter(data);
    };

    return (
        <Dropdown closeOnSelect={false}>
            <DropdownTrigger>
                <Button radius='sm' variant='bordered' startContent={<FunnelIcon className='size-4' />}>
                    Saring
                </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Wilayah">
                <DropdownItem onClick={() => handleApply('province')} key="province">Provinsi</DropdownItem>
                <DropdownItem onClick={() => handleApply('regency')} key="regency">Daerah</DropdownItem>
                <DropdownItem onClick={() => handleApply('district')} key="district">Kabupaten</DropdownItem>
                <DropdownItem onClick={() => handleApply('village')} key="village">Desa</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    )
}

// function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
//     const safeData = Array.isArray(data) ? data : []; // Pastikan data adalah array
//     return (
//         <>
//             <Card radius="sm" className="col-span-4">
//                 <CardHeader>
//                     <span className="text-primary text-xl font-bold">{title}</span>
//                 </CardHeader>
//                 <CardBody className="w-full flex flex-col items-center py-5 text-center">
//                     <BarChart
//                         xAxis={[
//                             {
//                                 scaleType: "band",
//                                 data: safeData?.map((item) => item[dataGraphSeries] || "N/A"),
//                                 label: columns[0],
//                                 barGapRatio: 0,
//                                 categoryGapRatio: 0.4,
//                             },
//                         ]}
//                         series={[
//                             {
//                                 data: safeData?.map((item) => item[dataGraphxAxis] || 0),
//                             },
//                         ]}
//                         height={300}
//                     />
//                 </CardBody>
//             </Card>

//             <div className="col-span-4 mt-5">
//                 <Table aria-label="Data Table">
//                     <TableHeader>
//                         {columns?.map((col, idx) => (
//                             <TableColumn key={idx}>{col}</TableColumn>
//                         ))}
//                     </TableHeader>
//                     <TableBody>
//                         {safeData?.map((item, index) => (
//                             <TableRow key={index}>
//                                 {dataKeys.map((key, idx) => (
//                                     <TableCell key={idx}>
//                                         {key === "periode_bulan" 
//                                             ? translateMonth(item[key]) || "N/A" 
//                                             : item[key] || "N/A"}
//                                     </TableCell>
//                                 ))}
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </div>
//         </>
//     );
// }

function renderChartAndTableForRealisasi(data, title, columns, dataKeys, dataGraphSeries, dataGraphxAxis) {
    const safeData = Array.isArray(data) ? data : [];
    
    // Sort Data Berdasarkan Total
    const sortedData = safeData.sort((a, b) => Number(b[dataGraphxAxis]) - Number(a[dataGraphxAxis]));
  
    const chartOptions = {
      chart: {
        type: "column",
        scrollablePlotArea: {
          minWidth: 800, // Tambahkan scroll jika data banyak
        },
      },
      title: {
        text: title,
      },
      xAxis: {
        categories: sortedData.map((item) => item[dataGraphSeries] || "N/A"),
        title: {
          text: columns[0],
        },
        labels: {
          rotation: -45,
          style: {
            fontSize: "10px",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Jumlah",
        },
        labels: {
          formatter: function () {
            return this.value >= 1000000
              ? (this.value / 1000000).toFixed(1) + "M"
              : this.value;
          },
        },
      },
      series: [
        {
          name: "Total",
          data: sortedData.map((item) => Number(item[dataGraphxAxis]) || 0),
        },
      ],
      tooltip: {
        pointFormatter: function () {
          return `<b>${this.category}</b>: ${this.y.toLocaleString()} Total`;
        },
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: "{point.y:.0f}",
            style: {
              fontSize: "10px",
            },
          },
        },
      },
      exporting: {
        url: HIGHCHART_URL,
        enabled: true,
        showTable: true,
        },
    };
  
    return (
      <>
        <Card radius="sm" className="col-span-4">
          <CardHeader>
            <span className="text-primary text-xl font-bold">{title}</span>
          </CardHeader>
          <CardBody className="w-full">
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          </CardBody>
        </Card>
  
        <div className="col-span-4 mt-5">
          <Table aria-label="Data Table">
            <TableHeader>
              {columns.map((col, idx) => (
                <TableColumn key={idx}>{col}</TableColumn>
              ))}
            </TableHeader>
            <TableBody>
              {sortedData.map((item, index) => (
                <TableRow key={index}>
                  {dataKeys.map((key, idx) => (
                    <TableCell key={idx}>{item[key] || "N/A"}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </>
    );
  }


